import React from "react";

interface GlassBackgroundProps {
  children?: React.ReactNode;
  className?: string;
}

export default function GlassBackground({
  children,
  className = "",
}: GlassBackgroundProps) {
  return (
    <div className={`relative flex flex-1 overflow-hidden h-full bg-[#f0f0f3] text-foreground font-sans ${className}`}>
      {/* High Contrast Background Elements for Glass Visibility */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] size-[60%] rounded-full bg-accent/15 blur-[120px] animate-pulse" />
        <div className="absolute bottom-[10%] right-[-5%] size-[50%] rounded-full bg-[#5e5e62]/10 blur-[100px]" />
        <div className="absolute top-[40%] left-[20%] size-[30%] rounded-full bg-accent/10 blur-[140px]" />
        <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#000_1px,transparent_1px)] bg-size-[20px_20px]" />
      </div>

      <div className="relative flex flex-1 overflow-hidden">
        {children}
      </div>
    </div>
  );
}
